// Strip prefixes to save local storage

import { stripPrefix } from 'utils/stringHelpers';
import { CREATIVE_LIBRARY_FILTER_OPTIONS } from '../constants';
import { CreativeLibraryFilterPrefix, FilterOption, Filters } from '../types';

// parses to number if isNumber attribute in constants
export const getPrefixToSelectedFiltersMap = (filters: string[][]) => {
  return filters.reduce(
    (acc, filterOption, idx) => {
      const filter = CREATIVE_LIBRARY_FILTER_OPTIONS[idx];
      const { prefix } = filter;

      const selectedFilterValues = filterOption.map((str: string): FilterOption => {
        const filterString = stripPrefix(prefix, str);
        return filter.isNumber ? parseInt(filterString, 10) : filterString;
      });

      return { ...acc, [prefix as CreativeLibraryFilterPrefix]: selectedFilterValues };
    },
    {} as Record<CreativeLibraryFilterPrefix, Filters>,
  );
};

export const flattenFilters = (filters: Filters[]): string[] => {
  return filters
    .map((filterOption: Filters, idx) => {
      const option = CREATIVE_LIBRARY_FILTER_OPTIONS[idx];
      return filterOption.map((str) => `${option?.prefix}${str}`);
    })
    .flat();
};
